import { DateTime } from 'luxon';
import type { TFunction } from 'i18next';

export function formatDateRange(
    dateFrom: string | null | undefined,
    dateTo: string | null | undefined,
    locale: string,
    timeZone: string,
    t: TFunction
): string {
    const dtFrom = dateFrom ? DateTime.fromISO(dateFrom, { zone: timeZone }) : null;
    const dtTo = dateTo ? DateTime.fromISO(dateTo, { zone: timeZone }) : null;

    const formattedFrom =
        dtFrom && dtFrom.isValid ? dtFrom.setLocale(locale).toLocaleString(DateTime.DATE_FULL) : null;

    const formattedTo = dtTo && dtTo.isValid ? dtTo.setLocale(locale).toLocaleString(DateTime.DATE_FULL) : null;

    if (formattedFrom && formattedTo) {
        return `${formattedFrom} - ${formattedTo}`;
    }

    if (formattedFrom) {
        return t('intervalFrom', { ns: 'translation', datefrom: formattedFrom });
    }

    if (formattedTo) {
        return t('intervalUntil', { ns: 'translation', dateto: formattedTo });
    }

    return t('intervalWholeTerm', { ns: 'translation' });
}
